//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Spinner from "../shared/Spinner";
import { Money } from 'v-money';
export default {
    components: { Money: Money, Spinner: Spinner },
    props: {
        applicant: {
            type: Object
        }
    },
    watch: {
        applicant: function applicant(_applicant, oldApplicant) {
            if (_applicant.id) {
                this.loadApplicant();
            }
        }
    },
    data: function data() {
        return {
            money: {
                prefix: '$',
                suffix: '',
                thousands: ',',
                decimal: '.',
                precision: 0
            },
            modalName: 'Screening Application',
            applicant_id: "",
            transunion_id: "",
            today: null,
            isLoading: false,
            deposit: "",
            rentAmount: "",
            applicationNumber: "",
            marketingSource: this.getDefaultSelection(),
            leaseTerm: "",
            transUnionApplicants: [],
            transUnionApplicantsPayLoad: [],
            oldInformation: {
                firstName: "",
                lastName: "",
                streetAddress: "",
                city: "",
                state: "",
                postalCode: ""
            },
            isSSN: true,
            isCreditCheck: true,
            overWriteInformation: false,
            step: 1,
            maxStep: 2,
            loadApplicantData: true,
            showApplicant: 0,
            validation: {
                step1: [{ model: 'rentAmount', rules: 'required | integer | min:1' }, { model: 'leaseTerm', rules: 'required | integer | min:1' }, { model: 'marketingSource.value', rules: 'required | string' }],
                step2: []
            }
        };
    },

    computed: {},
    mounted: function mounted() {
        var _this = this;

        Event.$on('Screening Application', function () {
            _this.loadApplicantData = true;
            _this.$initValidator();
            _this.today = _this.getDOB();
            Event.$emit('open-slide', _this.modalName);
        });

        Event.$on('link Screening Application', function (item) {
            _this.$initValidator();
            _this.today = _this.getDOB();
            Event.$emit('open-slide', _this.modalName);
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('Screening Application');
        Event.$off('link Screening Application');
    },

    methods: {
        changeTab: function changeTab(idx) {
            this.showApplicant = idx;
        },
        addApplicant: function addApplicant() {
            this.transUnionApplicants.push({
                firstName: "",
                middleName: "",
                lastName: "",
                suffix: this.getDefaultSelection(),
                dateOfBirth: '',
                email: '',
                ssn: "",
                streetAddress: "",
                unitNumber: "",
                city: "",
                state: this.getDefaultSelection(),
                postalCode: "",
                employeeStatus: this.getDefaultSelection(),
                incomeAmount: "",
                incomePeriod: this.getDefaultSelection(),
                otherIncome: "",
                otherIncomePeriod: this.getDefaultSelection(),
                totalAssets: "",
                isEviction: true,
                isCriminal: true,
                isCreditCheck: true
            });
            this.showApplicant = this.transUnionApplicants.length - 1;
        },
        deleteApplicant: function deleteApplicant(idx) {
            this.transUnionApplicants.splice(idx, 1);
            if (this.showApplicant === idx) {
                this.showApplicant = idx - 1;
            }
        },
        getDefaultSelection: function getDefaultSelection() {
            return {
                label: "Select ...",
                value: ""
            };
        },
        prepareRunScreeningPayload: function prepareRunScreeningPayload() {
            this.transUnionApplicantsPayLoad = this.transUnionApplicants.map(function (t) {
                return {
                    firstName: t.firstName,
                    middleName: t.middleName,
                    lastName: t.lastName,
                    suffix: t.suffix.value,
                    dateOfBirth: moment(t.dateOfBirth).format("YYYY-MM-DD"),
                    email: t.email,
                    ssn: t.ssn.split("-").join(""),
                    streetAddress: t.streetAddress,
                    unitNumber: t.unitNumber,
                    city: t.city,
                    state: t.state.value,
                    postalCode: t.postalCode.replace("-", ""),
                    employeeStatus: t.employeeStatus.value,
                    incomeAmount: t.incomeAmount,
                    incomePeriod: t.incomePeriod.value,
                    otherIncome: t.otherIncome,
                    otherIncomePeriod: t.otherIncomePeriod.value,
                    assets: t.totalAssets,
                    eviction: t.isEviction,
                    criminal: t.isCriminal,
                    credit: t.isCreditCheck
                };
            });
            var sourceRef = this.applicant_id,
                propertyId = this.transunion_id,
                depositAmount = this.deposit,
                rentAmount = this.rentAmount,
                leaseTerm = this.leaseTerm,
                marketingSource = this.marketingSource.value,
                applicationNumber = this.applicationNumber,
                transUnionApplicants = this.transUnionApplicantsPayLoad;

            return {
                propertyId: propertyId,
                rentAmount: rentAmount,
                depositAmount: depositAmount,
                leaseTerm: leaseTerm,
                marketingSource: marketingSource,
                sourceRef: sourceRef,
                applicationNumber: applicationNumber,
                transUnionApplicants: transUnionApplicants
            };
        },
        loadLinkApplication: function loadLinkApplication(item) {
            this.loadApplicantData = false;
            var _applicant2 = this.applicant,
                applicant_id = _applicant2.id,
                transunion_property_id = _applicant2.property.transunion_property_id;

            this.applicant_id = applicant_id;
            this.transunion_id = transunion_property_id;
            var _item$application$app = item.application.applicants.applicant,
                firstName = _item$application$app.firstName,
                lastName = _item$application$app.lastName,
                postalCode = _item$application$app.postalCode,
                city = _item$application$app.city,
                state = _item$application$app.state,
                streetAddress = _item$application$app.streetAddress,
                employmentStatus = _item$application$app.employmentStatus,
                employmentIncome = _item$application$app.employmentIncome,
                employmentIncomePeriod = _item$application$app.employmentIncomePeriod,
                otherIncome = _item$application$app.otherIncome,
                assets = _item$application$app.assets,
                otherIncomePeriod = _item$application$app.otherIncomePeriod,
                criminalRecommendation = _item$application$app.criminalRecommendation,
                evictionRecommendation = _item$application$app.evictionRecommendation;

            this.transUnionApplicant.firstName = firstName;
            this.transUnionApplicant.lastName = lastName;
            this.transUnionApplicant.address.postalCode = postalCode;
            this.transUnionApplicant.address.city = city;
            this.transUnionApplicant.address.state = state ? this.getStates().filter(function (_ref) {
                var value = _ref.value;
                return value.toLowerCase() === state.toLowerCase();
            })[0] : this.transUnionApplicant.address.state;
            this.transUnionApplicant.address.streetAddress = streetAddress;
            var _item$application = item.application,
                rentAmount = _item$application.rentAmount,
                leaseTerm = _item$application.leaseTerm,
                depositAmount = _item$application.depositAmount,
                applicationNumber = _item$application.applicationNumber;

            this.leaseTerm = leaseTerm;
            this.deposit = depositAmount;
            this.applicationNumber = applicationNumber;
            this.credit.employeeStatus = employmentStatus ? this.getEmployeeStatuses().filter(function (_ref2) {
                var value = _ref2.value;
                return value === employmentStatus;
            })[0] : this.credit.employeeStatus;
            this.credit.incomeAmount = employmentIncome;
            this.credit.incomePeriod = employmentIncomePeriod ? this.getIncomePeriods().filter(function (_ref3) {
                var value = _ref3.value;
                return value === employmentIncomePeriod;
            })[0] : this.credit.incomePeriod;
            this.credit.otherIncome = otherIncome;
            this.credit.otherIncomePeriod = otherIncomePeriod ? this.getIncomePeriods().filter(function (_ref4) {
                var value = _ref4.value;
                return value === otherIncomePeriod;
            })[0] : this.credit.otherIncomePeriod;
            this.credit.totalAssets = assets;
            this.isCriminal = criminalRecommendation === 'Accept';
            this.isEviction = evictionRecommendation === 'Accept';
            this.loadOldInformation();
        },
        loadOldInformation: function loadOldInformation() {
            var _applicant$person = this.applicant.person,
                first_name = _applicant$person.first_name,
                last_name = _applicant$person.last_name,
                address = _applicant$person.address,
                city = _applicant$person.city,
                state = _applicant$person.state,
                postal = _applicant$person.postal;

            this.oldInformation.firstName = first_name;
            this.oldInformation.lastName = last_name;
            this.oldInformation.streetAddress = address;
            this.oldInformation.city = city;
            this.oldInformation.state = state ? this.getStates().filter(function (_ref5) {
                var value = _ref5.value;
                return value.toLowerCase() === state.toLowerCase();
            })[0] : this.oldInformation.state;
            this.oldInformation.postalCode = postal;
        },
        loadApplicant: function loadApplicant() {
            if (this.applicant.id && this.loadApplicantData) {
                var _applicant3 = this.applicant,
                    applicant_id = _applicant3.id,
                    transunion_property_id = _applicant3.property.transunion_property_id;

                this.applicant_id = applicant_id;
                this.transunion_id = transunion_property_id;
                var _applicant$person2 = this.applicant.person,
                    first_name = _applicant$person2.first_name,
                    last_name = _applicant$person2.last_name,
                    dob = _applicant$person2.dob,
                    address = _applicant$person2.address,
                    city = _applicant$person2.city,
                    state = _applicant$person2.state,
                    ssn = _applicant$person2.ssn,
                    postal = _applicant$person2.postal,
                    source = _applicant$person2.source,
                    email = _applicant$person2.email;

                if (this.transUnionApplicants.length < 1) {
                    this.transUnionApplicants.push({
                        firstName: first_name,
                        middleName: "",
                        lastName: last_name,
                        suffix: this.getDefaultSelection(),
                        dateOfBirth: dob && dob !== "null" ? moment(dob).format("MM/DD/YYYY") : '',
                        ssn: "",
                        email: email,
                        streetAddress: address && address !== "null" ? address : "",
                        unitNumber: "",
                        city: city && city !== "null" ? city : "",
                        state: state && state !== "null" ? this.getStates().filter(function (_ref6) {
                            var value = _ref6.value;
                            return value.toLowerCase() === state.toLowerCase();
                        })[0] : this.transUnionApplicant.state,
                        postalCode: postal && postal !== "null" ? postal : "",
                        employeeStatus: this.getDefaultSelection(),
                        incomeAmount: "",
                        incomePeriod: this.getDefaultSelection(),
                        otherIncome: "",
                        otherIncomePeriod: this.getDefaultSelection(),
                        totalAssets: "",
                        isEviction: true,
                        isCriminal: true,
                        isCreditCheck: true,
                        applicant_id: applicant_id
                    });
                }
                this.marketingSource = source && source !== "null" ? this.getMarketingSources().filter(function (_ref7) {
                    var label = _ref7.label;
                    return label.toLowerCase() === source.toLowerCase();
                })[0] : this.marketingSource;

                this.marketingSource = this.marketingSource || this.getDefaultSelection();
                // this.transUnionApplicant.address.state =  this.transUnionApplicant.address.state || this.getDefaultSelection();
            }
        },
        getDOB: function getDOB() {
            return moment().subtract(18, 'years').format('MM/DD/YYYY');
        },
        runApplicantScreening: function runApplicantScreening() {
            var _this2 = this;

            this.validation.step2 = [];
            this.transUnionApplicants.map(function (value, key) {
                _this2.validation.step2.push({ model: 'transUnionApplicants.' + key + '.firstName', rules: 'required | string' }, { model: 'transUnionApplicants.' + key + '.lastName', rules: 'required | string' }, { model: 'transUnionApplicants.' + key + '.dateOfBirth', rules: 'required | date | before_or_equal:today' }, { model: 'transUnionApplicants.' + key + '.ssn', rules: 'required_if:isSSN | string' }, { model: 'transUnionApplicants.' + key + '.email', rules: 'required | email' }, { model: 'transUnionApplicants.' + key + '.streetAddress', rules: 'required | string' }, { model: 'transUnionApplicants.' + key + '.city', rules: 'required | string' }, { model: 'transUnionApplicants.' + key + '.state.value', rules: 'required | string' }, { model: 'transUnionApplicants.' + key + '.postalCode', rules: 'required | string' }, { model: 'transUnionApplicants.' + key + '.employeeStatus.value', rules: 'required_if:isCreditCheck | string' }, { model: 'transUnionApplicants.' + key + '.incomeAmount', rules: 'required_if:isCreditCheck | integer | min:1' }, { model: 'transUnionApplicants.' + key + '.incomePeriod.value', rules: 'required_if:isCreditCheck | string' });
            });
            var step2 = this.validation.step2;

            this.validator.setRules(step2).validate();

            if (this.validator.fails()) {
                return;
            }

            if (!this.overWriteInformation && !this.loadApplicantData && (this.oldInformation.firstName !== this.transUnionApplicant.firstName || this.oldInformation.lastName !== this.transUnionApplicant.lastName || this.oldInformation.streetAddress !== this.transUnionApplicant.address.streetAddress || this.oldInformation.city !== this.transUnionApplicant.address.city || this.oldInformation.state !== this.transUnionApplicant.address.state || this.oldInformation.postalCode !== this.transUnionApplicant.address.postalCode)) {
                this.$snotify.error("Current information is different from the old information.");
                return;
            }

            this.isLoading = true;
            axios.post('/prototype/trans-union', this.prepareRunScreeningPayload()).then(function (response) {
                _this2.isLoading = false;
                if (response.data.error) {
                    _this2.$snotify.error("Error Running Resident Screening: " + response.data.error);
                } else {
                    _this2.$snotify.success("Resident Screening started successfully.");
                    Object.assign(_this2.$data, _this2.$options.data.apply(_this2));
                    Event.$emit("close-slide", _this2.modalName);
                    Event.$emit("view-applicant", _this2.applicant);
                    _this2.loadApplicantData = true;
                }
            }).catch(function (err) {
                _this2.isLoading = false;
            });
        },
        goToNextStep: function goToNextStep() {
            this.marketingSource = this.marketingSource || this.getDefaultSelection();

            var step1 = this.validation.step1;

            this.validator.setRules(step1).validate();

            if (this.validator.fails()) {
                return;
            }
            this.step++;
        },
        cancel: function cancel() {
            Object.assign(this.$data, this.$options.data.apply(this));
            Event.$emit("close-slide", this.modalName);
        },
        getMarketingSources: function getMarketingSources() {
            return [{ label: "Apartment Guide", value: "1" }, { label: "Apartment Map", value: "2" }, { label: "Apartment Shoppers Guide", value: "3" }, { label: "Billboard", value: "4" }, { label: "Bootleg Signs", value: "5" }, { label: "Locator/Broker", value: "6" }, { label: "Company Website", value: "7" }, { label: "Drive-By", value: "8" }, { label: "Company Employee", value: "9" }, { label: "Former Resident", value: "10" }, { label: "For Rent", value: "11" }, { label: "Friend", value: "12" }, { label: "Newspaper", value: "13" }, { label: "On-Line General Resource", value: "14" }, { label: "Other", value: "15" }, { label: " Other Magazin", value: "16" }, { label: "Current Resident", value: "17" }, { label: "Inter-Property Transfer", value: "18" }, { label: " Unspecified", value: "19" }, { label: "Yellow Pages", value: "20" }, { label: "Apartment Blue Book", value: "21" }, { label: "Apartments.com", value: "22" }, { label: "Company Property Listing", value: "23" }, { label: "Direct Mail", value: "24" }, { label: "Homestore.com", value: "25" }, { label: "Locator 1", value: "26" }, { label: "Locator 2", value: "27" }, { label: "Locator 3", value: "28" }, { label: "Property Newsletter", value: "29" }, { label: "Rent.net", value: "30" }, { label: "Resident Referral", value: "31" }, { label: "Showcase", value: "32" }, { label: "Chamber of Commerce", value: "33" }, { label: "Apartment Book", value: "34" }, { label: "Apartment Finder", value: "35" }, { label: "Apartment source", value: "36" }, { label: "Flyer/Brochure", value: "37" }, { label: "Marketing Agency", value: "38" }];
        },
        getSuffixOptions: function getSuffixOptions() {
            return [{ label: "I", value: "I" }, { label: "II", value: "II" }, { label: "III", value: "III" }, { label: "IV", value: "IV" }, { label: "JR", value: "JR" }, { label: "SR", value: "SR" }];
        },
        getStates: function getStates() {
            return [{
                "value": "AL",
                "label": "Alabama"
            }, {
                "value": "AK",
                "label": "Alaska"
            }, {
                "value": "AZ",
                "label": "Arizona"
            }, {
                "value": "AR",
                "label": "Arkansas"
            }, {
                "value": "CA",
                "label": "California"
            }, {
                "value": "CO",
                "label": "Colorado"
            }, {
                "value": "CT",
                "label": "Connecticut"
            }, {
                "value": "DE",
                "label": "Delaware"
            }, {
                "value": "DC",
                "label": "District of Columbia"
            }, {
                "value": "FL",
                "label": "Florida"
            }, {
                "value": "GA",
                "label": "Georgia"
            }, {
                "value": "HI",
                "label": "Hawaii"
            }, {
                "value": "ID",
                "label": "Idaho"
            }, {
                "value": "IL",
                "label": "Illinois"
            }, {
                "value": "IN",
                "label": "Indiana"
            }, {
                "value": "IA",
                "label": "Iowa"
            }, {
                "value": "KS",
                "label": "Kansas"
            }, {
                "value": "KY",
                "label": "Kentucky"
            }, {
                "value": "LA",
                "label": "Louisiana"
            }, {
                "value": "ME",
                "label": "Maine"
            }, {
                "value": "MD",
                "label": "Maryland"
            }, {
                "value": "MA",
                "label": "Massachusetts"
            }, {
                "value": "MI",
                "label": "Michigan"
            }, {
                "value": "MN",
                "label": "Minnesota"
            }, {
                "value": "MS",
                "label": "Mississippi"
            }, {
                "value": "MO",
                "label": "Missouri"
            }, {
                "value": "MT",
                "label": "Montana"
            }, {
                "value": "NE",
                "label": "Nebraska"
            }, {
                "value": "NV",
                "label": "Nevada"
            }, {
                "value": "NH",
                "label": "New Hampshire"
            }, {
                "value": "NJ",
                "label": "New Jersey"
            }, {
                "value": "NM",
                "label": "New Mexico"
            }, {
                "value": "NY",
                "label": "New York"
            }, {
                "value": "NC",
                "label": "North Carolina"
            }, {
                "value": "ND",
                "label": "North Dakota"
            }, {
                "value": "OH",
                "label": "Ohio"
            }, {
                "value": "OK",
                "label": "Oklahoma"
            }, {
                "value": "OR",
                "label": "Oregon"
            }, {
                "value": "PA",
                "label": "Pennsylvania"
            }, {
                "value": "PR",
                "label": "Puerto Rico"
            }, {
                "value": "RI",
                "label": "Rhode Island"
            }, {
                "value": "SC",
                "label": "South Carolina"
            }, {
                "value": "SD",
                "label": "South Dakota"
            }, {
                "value": "TN",
                "label": "Tennessee"
            }, {
                "value": "TX",
                "label": "Texas"
            }, {
                "value": "UT",
                "label": "Utah"
            }, {
                "value": "VT",
                "label": "Vermont"
            }, {
                "value": "VA",
                "label": "Virginia"
            }, {
                "value": "VI",
                "label": "Virgin Island"
            }, {
                "value": "WA",
                "label": "Washington"
            }, {
                "value": "WV",
                "label": "West Virginia"
            }, {
                "value": "WI",
                "label": "Wisconsin"
            }, {
                "value": "WY",
                "label": "Wyoming"
            }];
        },
        getIncomePeriods: function getIncomePeriods() {
            return [{
                label: "Monthly",
                value: "2"
            }, {
                label: "Yearly",
                value: "1"
            }];
        },
        getEmployeeStatuses: function getEmployeeStatuses() {
            return [{
                label: "Employed",
                value: "1"
            }, {
                label: "Student",
                value: "2"
            }, {
                label: "Retired",
                value: "3"
            }, {
                label: "Other",
                value: "4"
            }];
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/applicants/ApplicantScreeningApplication.vue
// module id = jXlj
// module chunks = 0 1